import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import Container from './Container';
import Sidebar from './Sidebar';
import { config as appConfig } from '../config';
import { getPRU } from '../lib/localStorageHandler';

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isRegistedUser, setIsRegistedUser] = useState(false);

  useEffect(() => {
    const isPRU = getPRU(); // Previously registered user
    if (isPRU) setIsRegistedUser(true);
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderSignInButton = () => {
    if (!isRegistedUser)
      return (
        <div className="right-wrapper large-screen">
          <a
            className="right-link"
            id="sign-in-button"
            href={`${appConfig.screenappFrontendBaseUrl}/#/signin`}
          >
            Sign In
          </a>
          <a
            className="red"
            id="sign-up-button"
            href={`${appConfig.screenappFrontendBaseUrl}/#/signup`}
          >
            Sign Up
          </a>
        </div>
      );
    return (
      <div className="right-wrapper large-screen">
        <a
          className="red"
          id="sign-in-button"
          href={`${appConfig.screenappFrontendBaseUrl}/#/signin`}
        >
          Sign In
        </a>
        <a
          className="right-link"
          id="sign-up-button"
          href={`${appConfig.screenappFrontendBaseUrl}/#/signup`}
        >
          Sign Up
        </a>
      </div>
    );
  };

  return (
    <header>
      <Container>
        <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
        <Link to="/" className="logo">
          <span className="red">SCREEN</span>
          <span>APP</span>
        </Link>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="end"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="small-screen"
        >
          <MenuIcon />
        </IconButton>
        <div className="center-wrapper large-screen">
          <Link to="#Features">Features</Link>
          <Link to="#pricing">Pricing</Link>
          <Link to="https://screenapp.io/blog/" target="blank">
            Resources
          </Link>

          {/* <Button
            aria-controls="dropdown"
            aria-haspopup="true"
            onClick={handleClick}
          >
            Resources
          </Button> */}

          <a href="#contact">Contact</a>
        </div>
        {renderSignInButton()}
      </Container>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="header-dropdown-wrapper"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <MenuItem>
          <Link to="https://screenapp.io/blog/" target="blank">
            Blog
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="https://screenapp.io/blog/faq.html" target="blank">
            FAQ
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/" target="blank">
            Support
          </Link>
        </MenuItem>
      </Menu>
      <div className="blur-background" />
    </header>
  );
};

export default Header;
